<div *ngFor="let alert of alerts" class="{{cssClass(alert)}} alert-dismissable d-flex align-items-center justify-content-between">
  <div class="d-flex align-items-center">
    <mat-icon>error_outline</mat-icon>
    <div [innerHTML]="alert.message"></div>
  </div>
  <a class="close" (click)="removeAlert(alert)">&times;</a>
</div>